import {AppStore} from "../../desktop";
import {Payment} from "../../models/Payment";
import {PaymentsActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";
import {Customer} from "../../models/Customer";
import {InvoicesActionTypes} from "../invoices";

export const actionPaymentFetchAll = () => {
	AppStore.dispatch({type: PaymentsActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionPaymentFetchAllCompleted = (payments: Payment[]) => {
	AppStore.dispatch({type: PaymentsActionTypes.FETCH_ALL_COMPLETED, payload: payments})
}

export const actionPaymentFetch = (payment: Payment) => {
	AppStore.dispatch({type: PaymentsActionTypes.FETCH_ONE_REQUEST, payload: payment})
}

export const actionPaymentFetchCompleted = (payment: Payment) => {
	AppStore.dispatch({type: PaymentsActionTypes.FETCH_ONE_COMPLETED, payload: payment})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: payment})
}

export const actionPaymentSave = (payment: Payment) => {
	AppStore.dispatch({type: PaymentsActionTypes.SAVE_REQUEST, payload: payment})
}

export const actionPaymentSaveCompleted = (payment: Payment) => {
	AppStore.dispatch({type: PaymentsActionTypes.SAVE_COMPLETED, payload: payment})
}

export const actionPaymentDelete = (payment: Payment) => {
	AppStore.dispatch({type: PaymentsActionTypes.DELETE_REQUEST, payload: payment})
}

export const actionPaymentDeleteCompleted = (payment: Payment) => {
	AppStore.dispatch({type: PaymentsActionTypes.DELETE_COMPLETED, payload: payment})
}

export const actionDeletePayments = (payments: Payment[]) => {
	AppStore.dispatch({type: PaymentsActionTypes.DELETE_MULTIPLE_REQUEST, payload: payments})
}

export const actionDeletePaymentsCompleted = (payments: Payment[]) => {
	AppStore.dispatch({type: PaymentsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: payments})
}

export const actionPaymentFetchByCustomer = (customer: Customer) => {
	AppStore.dispatch({type: PaymentsActionTypes.FETCH_BY_CUSTOMER_REQUEST, payload: customer})
}

export const actionPaymentFetchByCustomerCompleted = (payments: Payment[]) => {
	AppStore.dispatch({type: PaymentsActionTypes.FETCH_BY_CUSTOMER_COMPLETED, payload: payments})
}
